import { createFileRoute } from "@tanstack/react-router";
import { redirectRemovedAuthor } from "@/lib/removedAuthors";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import Author from "@/pages/Author";

export const Route = createFileRoute("/en/author/$slug")({
  loader: ({ params }) => (redirectRemovedAuthor(params.slug, "/en"), loadContentMeta("authors", params.slug, "en")),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/author/${params.slug}`, loaderData),
  component: Author,
});

